import * as columnFormatters from "../../../components/column-formatters";

import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";

export const columns = [
  {
    dataField: "noIndex",
    text: "#",
    sort: true,
    show: true,
    format: {
      style: {
        width: "40px",
        minWidth: "40px",
      },
    },
  },
  {
    dataField: "uniqueIGN",
    text: "Company ID",
    sort: true,
    show: true,
  },
  {
    dataField: "user.gamerjiName",
    text: "Company Name",
    sort: true,
    show: true,
  },
  {
    dataField: "country",
    text: "Country",
    sort: true,
    show: true,
  },
  {
    dataField: "user.phone",
    text: "Total Ads",
    sort: true,
    show: true,
  },
  {
    dataField: "user.wallet.coinAmount",
    text: "Active Ads",
    sort: true,
    show: true,
  },
  {
    dataField: "rank",
    text: "Revenue",
    sort: true,
    show: true,
    format: {
      // type: 'textbox',
    },
  },
];

export const columns_contest_users = [
  {
    dataField: "noIndex",
    text: "#",
    sort: true,
    show: true,
    format: {
      style: {
        width: "40px",
        minWidth: "40px",
      },
    },
  },
  {
    dataField: "uniqueIGN",
    text: "Ads ID",
    sort: true,
    show: true,
  },
  {
    dataField: "user.gamerjiName",
    text: "Company name",
    sort: true,
    show: true,
  },
  {
    dataField: "country",
    text: "Countries",
    sort: true,
    show: true,
  },
  {
    dataField: "user.phone",
    text: "Brand Name",
    sort: true,
    show: true,
  },
  {
    dataField: "user.wallet.coinAmount",
    text: "Brand Image",
    sort: true,
    show: true,
  },
  {
    dataField: "rank",
    text: "Ads Link",
    sort: true,
    show: true,
    format: {
      // type: 'textbox',
    },
  },
  {
    dataField: "kills",
    text: "Ads Title 1",
    sort: true,
    show: true,
    format: {
      // type: 'textbox',
    },
  },
  {
    dataField: "rankAmount",
    text: "Ads Title 2",
    sort: true,
    show: true,
  },
  {
    dataField: "killAmount",
    text: "Deal Type",
    sort: true,
    show: true,
  },
  {
    dataField: "totalAmount",
    text: "Per day Capping",
    sort: true,
    show: true,
  },
  {
    dataField: "isHacking",
    text: "Ads Earning Currency",
    sort: true,
    show: true,
  },
  {
    dataField: "isProof",
    text: "Ads Earning Amount",
    sort: true,
    show: true,
  },
  {
    dataField: "joinedDate",
    text: "Total Earning",
    sort: true,
    show: true,
    format: {
      formatter: columnFormatters.dateFormatCol,
    },
  },
  {
    dataField: "joinedDate",
    text: "Impression",
    sort: true,
    show: true,
    format: {
      formatter: columnFormatters.timeFormatCol,
    },
  },
  {
    dataField: "joiningTransactionID",
    text: "Views",
    sort: true,
    show: true,
  },
  {
    dataField: "winningsDate",
    text: "Clicks",
    sort: true,
    show: true,
  },
];

export const columns_ads_log = [
  {
    dataField: "noIndex",
    text: "#",
    sort: true,
    show: true,
    format: {
      style: {
        width: "40px",
        minWidth: "40px",
      },
    },
  },
  // {
  //   dataField: "user_id",
  //   text: "User ID",
  //   sort: true,
  //   show: true,
  // },
  {
    dataField: "company_id", // Assuming 'company_id' contains the Company ID
    text: "Company ID",
    sort: true,
    show: true,
  },
  {
    dataField: "brand_name", // Assuming 'brandName' contains the Brand name
    text: "Brand name",
    sort: true,
    show: true,
  },
  {
    dataField: "country", // Assuming 'user.phone' contains the Country
    text: "Country",
    sort: true,
    show: true,
  },
  {
    dataField: "ads_id", // Assuming 'ads_id' contains the Ads ID
    text: "Ads ID",
    sort: true,
    show: true,
  },
  {
    dataField: "date", // Assuming 'date' contains the Date
    text: "Date",
    sort: true,
    show: true,
    format: {
      formatter: columnFormatters.dateFormatCol,
    },
  },
  {
    dataField: "time", // Assuming 'time' contains the Time
    text: "Time",
    sort: true,
    show: true,
    format: {
      formatter: columnFormatters.timeFormatCol,
    },
  },
  {
    dataField: "log_type", // Assuming 'log_type' contains the Log Type
    text: "Log Type",
    sort: true,
    show: true,
  },
];
